import { Chakra } from "@airhelp/react-ui-components";
import Accordion from "components/Accordion";
import Grid from "modules/common/components/Grid";
import { MinusIcon, PlusIcon } from "styles/icons";
import serializeAccordionItems from "./serializeAccordionItems";
import { customAccordionStyles } from "./styles";
import type { QuestionsAccordionProps } from "./QuestionsAccordion.d";

const { Box, Heading } = Chakra;

const QuestionsAccordion = ({ category: { name, questions } }: QuestionsAccordionProps) => (
  <Box bgColor="greyscale.300">
    <Grid mb={0} pb={20}>
      <Box gridColumn="1 / -1">
        <Heading mt={24} mb={4}>
          {name}
        </Heading>
        <Box sx={customAccordionStyles}>
          <Accordion
            variant="primary"
            items={serializeAccordionItems(questions)}
            icons={{
              open: <PlusIcon mt={2} color="primary.500" />,
              close: <MinusIcon mt={2} color="primary.500" />,
            }}
          />
        </Box>
      </Box>
    </Grid>
  </Box>
);

export default QuestionsAccordion;
